export default "__VITE_ASSET__a7ed57d0__"